module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_5.234c0ca6.gif";